import { createFileRoute, Link } from '@tanstack/react-router';
import { DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE, PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { ActionTileGrid, type ActionTileGridTile } from '@interxfi/design-system/components/action-tile/grid/action-tile-grid';
import FolderIcon from '@interxfi/design-system/icons/react/icon-folder';
import ReportsIcon from '@interxfi/design-system/icons/react/icon-reports';
import { FINCEN_MATCH_BASE_PATH } from '../../../../../../../features/watchlist/fincen/match/fincen-match-routing';
import { OFAC_MATCH_BASE_PATH } from '../../../../../../../features/watchlist/ofac/match/ofac-match-routing';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/')({
  head: () => getPageHead('Compliance'),
  component: ClearingComplianceIndex,
});

const routes = [
  {
    illustration: <FolderIcon aria-hidden />,
    title: 'OFAC',
    subtitle: 'Matches, Files, and Specially Designated Nationals',
    to: OFAC_MATCH_BASE_PATH,
  },
  {
    illustration: <FolderIcon aria-hidden />,
    title: 'FinCEN',
    subtitle: '314(a) Matches, Files, and Entries',
    to: FINCEN_MATCH_BASE_PATH,
  },
  {
    illustration: <ReportsIcon aria-hidden />,
    title: 'Reports',
    subtitle: 'Blue Sheets, CAT, CAIS, SEC 606(a)',
    to: '/clearing/compliance/reporting',
  },
] as const satisfies ActionTileGridTile[];

function ClearingComplianceIndex() {
  return (
    <PageLayout gap={7} maxWidthContainer={DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE}>
      <PageLayout.Section noBorder>
        <ActionTileGrid items={routes} LinkElement={Link} />
      </PageLayout.Section>
    </PageLayout>
  );
}
